module.exports = __webpack_public_path__ + "static/img/tou1.f1d0905.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tou1.jpg
// module id = A+pu
// module chunks = 1